class KeepTheLoopData {

    constructor(currentDocument, nextDocument, previousDocument, pathData) {
        this._documentIcon = currentDocument.icon;
        this._documentName = currentDocument.name;
        this._documentCompleted = currentDocument.completed;
        this._documentSection = pathData.sectionItemsDict[currentDocument.classId];
        this._currentDocument = currentDocument;
        this._nextDocument = nextDocument ? {id: nextDocument.id, isBlocked: nextDocument.is_blocked} : null;
        this._previousDocument = previousDocument ? {id: previousDocument.id, isBlocked: previousDocument.is_blocked} : null;
        this._testDocument = pathData.test.enabled ? pathData.test.document : null;
        this._numberOfContents = pathData.numberOfContents;
        this._completedDocuments = pathData.completedDocuments;

        this._listPathItems = Object.keys(pathData?.sectionItemsDict ?? {});

        this._altSectionName = pathData?.title ?? "";
    }

    getDocumentIcon() {
        return this._documentIcon;
    }

    getDocumentName() {
        return this._documentName;
    }

    getDocumentSection() {
        return this._documentSection;
    }

    getDocumentSectionName() {
        return this._documentSection?.header?.title || this._altSectionName;
    }

    getDocumentIsCompleted() {
        return this._documentCompleted;
    }

    getCurrentDocument() {
        return this._currentDocument;
    }

    getNextDocument() {
        return this._nextDocument;
    }

    getPreviousDocument() {
        return this._previousDocument;
    }

    getTestDocument() {
        return this._testDocument;
    }

    getNumberOfContents() {
        return this._numberOfContents;
    }

    getCompletedDocuments() {
        return this._completedDocuments;
    }

    setNextDocumentBlocked(isBlocked) {
        this._nextDocument.isBlocked = isBlocked;
    }

    setTestBlocked(isBlocked) {
        this._testDocument.isBlocked = isBlocked;
    }

}